<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger fade show" role="alert" v-if="orderValidationRulesResults !== null && orderValidationRulesResults.length > 0">
                    <div v-for="orderValidationRulesResult in orderValidationRulesResults">
                        <p v-if="!orderValidationRulesResult.isValid">
                            {{orderValidationRulesResult.message}}
                        </p>
                    </div>
                </div>
                <div v-if="!showSuccessMessage && !showErrorMessage">
                    <div>
                        <div class="row">
<!--                            <div class="col-md-6">-->
<!--                                <h5>Customer Details</h5>-->
<!--                                <p>-->
<!--                                    Customer: {{company.registeredCompanyName}}-->
<!--                                </p>-->
<!--                                <p v-if="company.tradingAs">-->
<!--                                    Trading As: {{company.tradingAs}}-->
<!--                                </p>-->
<!--                                <p v-if="company.branchName">-->
<!--                                    Branch: {{company.branchName}}-->
<!--                                </p>-->
<!--                                <p v-if="company.branchNumber">-->
<!--                                    Branch Number: {{company.branchNumber}}-->
<!--                                </p>-->
<!--                            </div>-->
                            <div class="col-md-6">
                                <h5>Shipping Address</h5>
                                <p>
                                    Street Address: {{customerShippingAddress.streetAddress}}
                                </p>
                                <p>
                                    City: {{customerShippingAddress.city}}
                                </p>
                                <p>
                                    Postal Code: {{customerShippingAddress.postalCode}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="text-danger" v-if="order.shippingAddressId.hasError">
                        {{order.shippingAddressId.errorMessage}}
                    </div>
                    <div class="form-group">
                        <label>Customer Purchase Order Number</label>
                        <div class="text-danger" v-if="order.customerPurchaseOrderNumber.hasError">
                            {{order.customerPurchaseOrderNumber.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.customerPurchaseOrderNumber.value"/>
                    </div>
                    <div class="pt-3">
                        <label>Select Product</label>
                        <div class="text-danger" v-if="order.productsHasError">
                            {{order.productsErrorMessage}}
                        </div>
                        <product-select-for-order :orderTypeId="orderTypeId"
                                                  :shippingAddressId="order.shippingAddressId.value"
                                                  :companyId="customerShippingAddress.companyId"
                                                  @productSelected="onProductSelected"></product-select-for-order>
                    </div>

                    <div class="form-group">
                        <label>Order Frequency</label>
                        <div class="text-danger" v-if="order.orderFrequency.hasError">
                            {{order.orderFrequency.errorMessage}}
                        </div>
                        <input class="form-control" type="number" min="1" max="10" v-model="order.orderFrequency.value" @input="onOrderFrequencyChange"/>
                    </div>

                    <div class="text-danger" v-if="order.expectedDatesOfDelivery.hasError">
                        {{order.expectedDatesOfDelivery.errorMessage}}
                    </div>
                    <div class="form-group" v-for="(dateField, index) in order.expectedDatesOfDelivery.value" :key="'delivery-date-' + index">
                        <label>Expected Date of Delivery - {{index + 1}}</label>
                        <div class="text-danger" v-if="dateField.hasError">
                            {{dateField.errorMessage}}
                        </div>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect' + index" :date="dateField.value"
                                     :startDate="expectedDateOfDeliveryStartDate"
                                     :initialiseDate="initialiseExpectedDate"
                                     @dateSelected="(date) => onExpectedDateOfDeliverySelect(date, index)"></date-picker>
                    </div>

                    <div class="form-group">
                        <label for="reasonInput">
                            Notes
                        </label>
                        <textarea class="form-control" id="reasonInput" v-model="order.notes" rows="4" cols="50"></textarea>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">PLACE ORDER</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>